import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';
import ConfirmPopup from '../../../../popup/ConfirmPopup/ConfirmPopup';

const ConfirmationDialog = ({ 
  showConfirmPopup, 
  handleConfirmSend, 
  setShowConfirmPopup 
}) => {
  return (
    <ConfirmPopup
      Visibility={showConfirmPopup}
      Title="Confirmação de Envio em Massa"
      Description={
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px'
        }}>
          {/* Warning section */}
          <Box sx={{
            padding: '24px',
            backgroundColor: ColorPalette.white,
            borderRadius: '12px',
            border: `1px solid ${ColorPalette.border}`,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
          }}>
            <Typography variant="subtitle1" sx={{
              fontWeight: 600,
              color: ColorPalette.blueDark,
              marginBottom: '16px',
              borderBottom: `1px solid ${ColorPalette.border}`,
              paddingBottom: '8px'
            }}>
              Diretrizes Importantes
            </Typography>
            
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px'
                }}>
                  <Box sx={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: ColorPalette.secondary,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Typography variant="body2" sx={{ color: ColorPalette.white, fontWeight: 600 }}>1</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{
                      fontWeight: 600,
                      color: ColorPalette.textDark,
                      marginBottom: '4px'
                    }}>
                      Use com moderação
                    </Typography>
                    <Typography variant="body2" sx={{ color: ColorPalette.textMedium }}>
                      Envios em massa devem ser utilizados apenas quando necessário
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px'
                }}>
                  <Box sx={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: ColorPalette.secondary,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Typography variant="body2" sx={{ color: ColorPalette.white, fontWeight: 600 }}>2</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{
                      fontWeight: 600,
                      color: ColorPalette.textDark,
                      marginBottom: '4px'
                    }}>
                      Cuidado com a quantidade de remetentes!
                    </Typography>
                    <Typography variant="body2" sx={{ color: ColorPalette.textMedium }}>
                      Recomendamos não enviar muitas mensagens por dia.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px'
                }}>
                  <Box sx={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: ColorPalette.secondary,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Typography variant="body2" sx={{ color: ColorPalette.white, fontWeight: 600 }}>3</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" sx={{
                      fontWeight: 600,
                      color: ColorPalette.textDark,
                      marginBottom: '4px'
                    }}>
                      Risco de bloqueio
                    </Typography>
                    <Typography variant="body2" sx={{ color: ColorPalette.textMedium }}>
                      Envios excessivos podem resultar em bloqueio pelo WhatsApp
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
          
          {/* Disclaimer */}
          <Box sx={{
            padding: '16px',
            backgroundColor: ColorPalette.errorLight,
            borderRadius: '12px',
            border: `1px solid ${ColorPalette.error}`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px'
          }}>
            <Box sx={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: ColorPalette.error,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}>
              <Typography variant="body2" sx={{ color: ColorPalette.white, fontWeight: 600 }}>!</Typography>
            </Box>
            <Typography variant="body1" sx={{
              fontWeight: 500,
              color: ColorPalette.error,
              textAlign: 'center',
              textTransform: 'uppercase'
            }}>
             Nós não nos responsabilizamos pelo mau uso desta funcionalidade!
            </Typography>
          </Box>
          
          {/* Best practices link */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '16px'
          }}>
            <Typography variant="body2" sx={{ color: ColorPalette.textMedium }}>
              Leia mais sobre as{' '}
              <a
                href="https://developer.z-api.io/tips/blockednumber"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: ColorPalette.blueMain,
                  textDecoration: 'none',
                  fontWeight: 500
                }}
              >
                boas práticas para evitar bloqueios no WhatsApp
              </a>
            </Typography>
          </Box>
        </Box>
      }
      ConfirmLabel="Entendo os riscos e desejo continuar"
      OnConfirm={handleConfirmSend}
      OnCancel={() => {}}
      OnHide={() => setShowConfirmPopup(false)}
    />
  );
};

export default ConfirmationDialog;